(function ($, Drupal) {

  'use strict';

  function getRowStatusClass(statusText) {
    var normalizedStatus = statusText.replace(/\s+/g, ' ').trim().toLowerCase();

    if (normalizedStatus === 'parduotas') {
      return 'status-sold';
    }

    if (normalizedStatus === 'rezervuota' || normalizedStatus === 'rezervuotas') {
      return 'status-reserved';
    }

    return 'status-free';
  }

  Drupal.behaviors.droopler_subtheme = {
    attach: function (context, settings) {
      $(once('droopler-subtheme-status-rows', '.view-butai tbody tr, .view-butai-flat tbody tr', context)).each(function () {
        var $row = $(this);
        var statusText = $row.find('.views-field-status').text();

        $row.removeClass('status-free status-sold status-reserved');
        $row.addClass(getRowStatusClass(statusText));
      });

      $(once('droopler-subtheme-price-no-euro', '.view-butai td.views-field-field-kaina, .view-butai-flat td.views-field-field-kaina', context)).each(function () {
        var $priceCell = $(this);
        var $row = $priceCell.closest('tr');

        if ($row.hasClass('status-sold')) {
          $priceCell.text('-');
          return;
        }

        var normalizedPrice = $priceCell.text().replace(/\s*€\s*/g, '').trim();

        $priceCell.text(normalizedPrice);
      });

    }
  };

})(jQuery, Drupal);
